<template>
  <div>
    <topPage :title="title" :bgImg="bgImg" />
    <doubleImageAndText
      id="next"
      img="archi2Shadow.png"
      img2="archi2.png"
      img3="PxMP.png"
      title="maison passive c’est quoi ?"
      text="La Maison Passive est une association loi 1901 qui a vu le jour en 2007. Écologiste et pro-active, elle propose, via la promotion d’un mode constructif particulièrement économe en énergie, une solution concrète pour mettre en place la transition énergétique. Elle a pour but de promouvoir le concept de construction selon le standard Bâtiment Passif, et d’encourager le développement d’une filière professionnelle. Elle compte actuellement 500 membres, professionnels et particuliers."
    ></doubleImageAndText>
    <FullSizeImg
      img="parc3.png"
      title="LE + POUR PAGESTI "
      text="Le bute de ce partenariat est de vous apporter une véritable expertise sur la transition énergétique acquise par nos conseiller former par l’association. Un accompagnement spécialisé et complet pour l’avenir de votre copropriété."
    ></FullSizeImg>
  </div>
</template>

<script>
import topPage from "../components/topPage";
import doubleImageAndText from "../components/doubleImageAndText";
import FullSizeImg from "../components/fullSizeImg";
export default {
  name: "MaisonPassive",
  components: { topPage, doubleImageAndText, FullSizeImg },
  data: () => ({
    title: "Partenriats",
    bgImg: "paris_illu.png",
  }),
};
</script>
